<mat-card [@snFadeInDown]>
  <form class="auth-reset-text-center" [formGroup]="form" (ngSubmit)="onFormSubmit()">
    <sn-brand-logo type="horizontal" class="brand-logo__margin-vertical-md"></sn-brand-logo>

    <sn-alert dense class="auth-reset-alert" type="danger" *ngIf="form.errors">
      <div *ngFor="let error of form.errors | keyvalue">
        <b>{{ error.key }}</b>: {{ error.value }}
      </div>
    </sn-alert>

    <main class="auth-reset-main" *ngIf="form">
      <h3>{{ 'common.forgotPassword' | t }}</h3>
      <p class="auth-reset-body-text muted-text">
        {{ 'auth.resetPassword.description' | t }}
      </p>
      <sn-reset-password-form [form]="form" [formModel]="formModel"></sn-reset-password-form>
    </main>

    <mat-card-actions>
      <button mat-raised-button color="accent" [mtBasicSpinner]="isLoading" [hideText]="true">
        {{ 'auth.resetPassword.sendButton' | t }}
      </button>
    </mat-card-actions>

    <footer class="pb-sm pt-xs">
      {{ 'auth.resetPassword.goBackToSignIn' | t }} <a [routerLink]="['/auth', 'sign-in']">{{ 'common.signIn' | t }}</a>
    </footer>
  </form>
</mat-card>
